import { defineComponent as _defineComponent } from 'vue'
import MerchantLayout from '@/components/area/mainland/merchant-banner/components/merchant-layout.vue';
import CommonBanner from './components/banner.vue';
import { ModuleName } from '@/types/module-type';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    moduleName: null
  },
  setup(__props: any) {




return { __sfc: true,MerchantLayout, CommonBanner }
}

})